import store from '../store';

export function indexTabItem(label, icon, attr = {}) {
  return { label, icon, attr };
}

export function routeTabItem(routeName, label, icon, attr = {}, perm) {
  let route = typeof routeName === 'string' ? { name: routeName } : routeName;
  if (!perm) perm = route.name;
  return { route, label, icon, attr, perm };
}

export function routeTabMenu(menu) {
  return menu
    .map(item => {
      return routeTabItem(item.route, item.label, item.icon, item.attr, item.perm);
    })
    .filter(({ perm }) => {
      let user = store.getters.user;
      return user && (!perm || user.can(perm));
    });
}

export default {
  indexTabItem,
  routeTabItem,
  routeTabMenu,
};
